import React from "react";
import PropTypes from "prop-types";
import className from "classnames";
import { Button, Icon, Card, CardBody, CardTitle, Row, Col } from "..";

const cardClasses = "card-container round-big shadow";
const buttonClasses = "ml-2";

export const CardContainer = props => (
  <Card className={className(cardClasses, props.className)}>
    <CardBody>
      <Row noGutters={true}>
        <Col>
          <CardTitle
            className={className(`font-weight-bold text-${props.titleColor}`, {
              "text-center": props.centeredTitle,
            })}
          >
            {props.title}
            {props.mandatoryTitle && (
              <small className="float-right text-muted">
                <Icon icon="asterisk" size="sm" className="mr-2 text-warning" />
                Denotes mandatory
              </small>
            )}
          </CardTitle>
        </Col>
        {props.titleButtons && (
          <Col className="d-flex justify-content-end">
            {props.titleButtons.map(button => (
              <Button
                key={button.text}
                className={className(buttonClasses, button.className)}
                color={button.color}
                onClick={button.clickHandler}
              >
                {button.text}
              </Button>
            ))}
          </Col>
        )}
      </Row>
      {props.children}
    </CardBody>
  </Card>
);

CardContainer.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  titleButtons: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      clickHandler: PropTypes.func.isRequired,
      className: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
    }),
  ),
  centeredTitle: PropTypes.bool,
  mandatoryTitle: PropTypes.bool,
  children: PropTypes.any,
};

CardContainer.defaultProps = {
  centeredTitle: false,
  mandatoryTitle: false,
  titleColor: "primary",
};

export default CardContainer;
